'use client'

import { Chip, Text, Spacer, Cell } from '@vinted/web-ui'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { FeedbackFilterType, clickEvent } from '@marketplace-web/profile/profile-feedback-data'

type Props = {
  selectedFeedbackFilterType: FeedbackFilterType
  showFilters?: boolean
  onClick: (feedbackFilterType: FeedbackFilterType) => void
}

const FeedbackFilters = ({ selectedFeedbackFilterType, showFilters, onClick }: Props) => {
  const translate = useTranslate('user.feedback.filters')
  const { track } = useTracking()

  const getCurrentTargetElement = (feedbackFilterType: FeedbackFilterType) => {
    switch (feedbackFilterType) {
      case FeedbackFilterType.Auto:
        return 'automatic_reviews'
      case FeedbackFilterType.Members:
        return 'member_reviews'
      default:
        return 'all_reviews'
    }
  }

  const handleClick = (feedbackFilterType: FeedbackFilterType) => () => {
    track(
      clickEvent({
        target: getCurrentTargetElement(feedbackFilterType),
        screen: 'user_profile',
      }),
    )
    onClick(feedbackFilterType)
  }

  if (!showFilters) return null

  return (
    <Cell>
      <div className="u-flexbox">
        <SeparatedList separator={<Spacer orientation={Spacer.Orientation.Vertical} />}>
          <Chip
            activated={selectedFeedbackFilterType === FeedbackFilterType.All}
            text={translate('all')}
            textType={Text.Type.Subtitle}
            onClick={handleClick(FeedbackFilterType.All)}
            radius={Chip.Radius.Round}
          />
          <Chip
            activated={selectedFeedbackFilterType === FeedbackFilterType.Members}
            text={translate('members')}
            textType={Text.Type.Subtitle}
            onClick={handleClick(FeedbackFilterType.Members)}
            radius={Chip.Radius.Round}
          />
          <Chip
            activated={selectedFeedbackFilterType === FeedbackFilterType.Auto}
            text={translate('auto')}
            textType={Text.Type.Subtitle}
            onClick={handleClick(FeedbackFilterType.Auto)}
            radius={Chip.Radius.Round}
          />
        </SeparatedList>
      </div>
    </Cell>
  )
}

export default FeedbackFilters
